import React from 'react'

import { Container } from 'reactstrap'

export const ThemesPage = ({ThemeItems, _themeCount, _themeCountText}) => {

    return (
        <Container>
            <h1>Your JobPassion Types&trade;</h1>
            <p>
                When you think about it, activities you feel deeply passionate about doing are ones that fill you
                with a sense of joy, meaning, and fulfillment.
            </p>
            <p>
                This is how you should expect to feel when your job is in direct alignment with your Core values. 
                That's why we use these values to identify the different job functions you
                may enjoy - your Job Passion Types&trade;.
            </p>

            <p>
                There are 21 Job Passion Types&trade; you can review the full list in the appendix at the end of your
                report.
            </p>
            <p>
                These are the work styles and roles most likely to bring you joy, purpose, and long-term
                success because they line up with who you actually are and what you care most about.
            </p>
            <p>
                For each, there is a brief description of the Job Passion Type&trade; and the high-ranked
                values that correspond to them. In the following section we’ll reveal the corresponding
                job titles and job descriptions that align with each Job Passion Type&trade;.
            </p>

            <p>
                Not all 21 Job Passion Types&trade; will apply to you because not all will be job functions that
                you enjoy doing.
            </p>
            <p><strong>
                Here are the Job Passion Types&trade; that you are most likely to enjoy based on how directly
                they align with your Core values.
            </strong></p>

            <ThemeItems />

            <h2>Summary</h2>
            <p>
                The job functions that you are most likely to enjoy are your Job Passion Types&trade;. The
                job descriptions created by your employer will determine how many of your Job Passion
                Types&trade; you get to apply in your role and how often you get to use them. The more time
                you can spend doing work that involves your Job Passion Types&trade;, the happier and more
                productive you will likely become in your role.
            </p>
        </Container>
    )
}

const Styles = {
    typeList: {
        paddingLeft: '27px'
    },
    typeListItem: {
        paddingLeft: '6px'
    }
}